import Vue from 'vue';
import Component from 'vue-class-component';
import SketchfabFrame from '../sketchfabFrame/SketchfabFrame.vue';
import { Prop, Inject } from 'vue-property-decorator';
import { ConfiguratorService, ConfiguratorServiceSettings, HideObjectsCommand, FilterOperators } from '../../services/sketchfab/index';
import { Store } from '@/store';
import { ServiceIdentifiers } from '@/services';
import { ComponentContainer } from '@/services/container';

import * as _ from 'lodash';
import ProductSelector from '@/components/productSelector/ProductSelector';
import { ProductDefinition } from '@/models/configuratorx/configuratorSchema';

import Axios from 'axios';
import { isArray } from 'util';
import { jsonBurositFormat } from '@/main';


@Component({
  components: {

  },
})

export default class SummaryModal extends Vue
{
  @Prop()
  img: string;
  @Prop()
  url: string;

  burositpc: string = "";


  public get seletedFamily()
  {
    return Store.state.family;
  }

  public get seletedProduct()
  {
    return Store.state.product;
  }

  public get selection()
  {

    if (!Store.state.selection)
    {
      return [];
    }
    return Store.state.selection;
  }

  public get sortedParts()
  {
    if (!Store.state.selection)
    {
      return [];
    }
    return _.orderBy(Store.state.selection.parts, ['order'], ['asc']);
  }

  created()
  {

  }

  getTexture(part)
  {
    const getPalettes = Store.state.configuratorConfig.definitions.palettes.find(x => x.id === part.palette);
    const getColor = getPalettes.colors.find(col => col.name === part.color);
    return './' + getColor.texture;
  }

  getColarDisplayName(part)
  {
    const getPalettes = Store.state.configuratorConfig.definitions.palettes.find(x => x.id === part.palette);
    const getColor = getPalettes.colors.find(col => col.name === part.color);
    return getColor.displayName;
  }

  printSummaryPage()
  {
    this.printElement(document.getElementsByClassName('summary-table')[0]);
  }

  mounted()
  {

  }

  printElement(elem)
  {
    const domClone = elem.cloneNode(true);

    const picClone = document.getElementsByClassName('model-pic')[0].cloneNode(true);
    const descClone = document.getElementsByClassName('description')[0].cloneNode(true);
    const $printSection = document.createElement('div');
    $printSection.id = 'printSection';
    document.body.appendChild($printSection);

    const printHeader = document.createElement('div');
    printHeader.innerHTML = '<h2> Bürosit İnteraktif 3D Ürün Konfigüratörü </h2>';
    printHeader.style.padding = '60px 20px 40px 20px';
    printHeader.style.textAlign = 'center';

    domClone.style.margin = '10px 20px 10px 30px';
    domClone.style.width = '95%';

    $printSection.innerHTML = '';


    $printSection.appendChild(printHeader);
    $printSection.appendChild(domClone);
    $printSection.appendChild(descClone);
    $printSection.appendChild(picClone);

    //console.log($printSection);
    //console.log(descClone);
    //console.log(domClone);
    window.print();
  }

  public get productConfiguration()
  {
    //if (!Store.state.selection)
    //{
    //  return [];
    //}

    //console.log("jsonReadArray: " + jsonReadArray);

    const _currentSelectionBurositFormat: { [key: string]: any } = {};

    const _selecteddParts: { [key: string]: string } = {};

    if (Store.state.selection)
    {
      if (Store.state.selection.parts)
      {
        Store.state.selection.parts.forEach(element =>
        {
          _selecteddParts[jsonBurositFormat[element["id"]]] = this.getMaterialBurositFormatName(element);

        });
      }

      const _currentSelection: { [key: string]: any } = Store.state.selection;
      _currentSelectionBurositFormat["MaterialAndColorSelections"] = _selecteddParts;

      const _keys = Object.keys(_currentSelection);
      _keys.forEach(element =>
      {
        //console.log(element);
        if (element != "parts")
        {
          _currentSelectionBurositFormat[jsonBurositFormat[element]] = jsonBurositFormat[_currentSelection[element]];
        }

      });
    }

    const configBurositFormat = {
      ProductName: Store.state.family.name,
      ProductModel: Store.state.product.name,
      Configuration: _currentSelectionBurositFormat,

    };

    //console.log(configBurositFormat);
    this.burositpc = JSON.stringify(configBurositFormat);
    return configBurositFormat;

  }

  getMaterialBurositFormatName(part)
  {
    const getPalettes = Store.state.configuratorConfig.definitions.palettes.find(x => x.id === part.palette);
    const getColor = getPalettes.colors.find(col => col.name === part.color);
    //console.log(getColor.name);
    //console.log(jsonBurositFormat[getColor.name]);
    return jsonBurositFormat[getColor.name];
  }

}



// WEBPACK FOOTER //
// ./src/components/summaryModal/summaryModal.ts